module.exports = __webpack_public_path__ + "img/reddit.265fc74a.svg";